import styled from '@emotion/styled';

export const Section = styled('section')<{
  collapse?: boolean;
  spacing?: number;
}>`
  margin-bottom: ${(p) =>
    p.collapse
      ? 0
      : p.spacing
      ? p.theme.spacing(p.spacing)
      : p.theme.spacing(8)}px;
  @media (max-width:480px) {
  margin-bottom: ${(p) =>
    p.collapse
      ? 0
      : p.spacing
      ? p.theme.spacing(p.spacing/2)
      : p.theme.spacing(4)}px;
} 
`;

export const SubSection = styled('section')<{
  collapse?: boolean;
  spacing?: number;
}>`
  margin-bottom: ${(p) =>
    p.collapse
      ? 0
      : p.spacing
      ? p.theme.spacing(p.spacing)
      : p.theme.spacing(2)}px;
`;

export const SectionTitle = styled('div')<{ hasSubHeadline?: boolean }>`
  margin-bottom: ${(p) =>
    p.hasSubHeadline ? p.theme.spacing(1) : p.theme.spacing(2)}px;
`;
